import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindReviewBeforeSubmitDraftsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FindReviewBeforeSubmitDraftsQuery = {
    __typename?: 'Query';
    findReviewBeforeSubmitDrafts?:
        | {
              __typename?: 'FindReviewBeforeSubmitDraftsPayload';
              drafts: Array<{
                  __typename?: 'AutoApplyDraft';
                  applicationDraftId: string;
                  state: Types.ReviewBeforeSubmitDraftState;
                  jobTitle: string;
                  jobLocation: string;
                  iaUid: string;
                  employerName?: string | null | undefined;
                  proctors: string;
                  deferMonetizationSignals: boolean;
                  applyableJob: {
                      __typename?: 'ReviewBeforeSubmitApplyableJob';
                      jobId: string;
                      clientJobRef?: string | null | undefined;
                  };
              }>;
          }
        | null
        | undefined;
};

export type CreateAutoApplyPreviewForConfirmationMutationVariables = Types.Exact<{
    input: Types.CreatePreviewInput;
    smartApplyApplicationStateInput: Types.SmartApplyApplicationStateInput;
}>;

export type CreateAutoApplyPreviewForConfirmationMutation = {
    __typename?: 'Mutation';
    smartApplyApplicationState: {
        __typename?: 'SmartApplyApplicationStateMutations';
        createPreview?:
            | {
                  __typename?: 'CreatePreviewSmartApplyApplicationStatePayload';
                  previewId?: string | null | undefined;
                  previewHtmlFileToken?: string | null | undefined;
                  encryptedApplicationId?: string | null | undefined;
                  previewHtmlContentHash?: string | null | undefined;
              }
            | null
            | undefined;
    };
};

export type SubmitAutoApplyApplicationMutationVariables = Types.Exact<{
    input: Types.SubmitApplicationInput;
    smartApplyApplicationStateInput: Types.SmartApplyApplicationStateInput;
}>;

export type SubmitAutoApplyApplicationMutation = {
    __typename?: 'Mutation';
    smartApplyApplicationState: {
        __typename?: 'SmartApplyApplicationStateMutations';
        submitApplication?:
            | {
                  __typename?: 'SubmitApplicationSmartApplyApplicationStatePayload';
                  saveFileSuccess?: boolean | null | undefined;
              }
            | null
            | undefined;
    };
};

export type SubmitReviewBeforeSubmitDraftMutationVariables = Types.Exact<{
    input: Types.SubmitReviewBeforeSubmitDraftInput;
}>;

export type SubmitReviewBeforeSubmitDraftMutation = {
    __typename?: 'Mutation';
    autoApplyMutations: {
        __typename?: 'AutoApplyOrchestratorMutations';
        submitReviewBeforeSubmitDraft?:
            | {
                  __typename?: 'SubmitReviewBeforeSubmitDraftAutoApplyOrchestratorPayload';
                  applicationDraftId: string;
                  success: boolean;
              }
            | null
            | undefined;
    };
};

export type ConfirmationPageSaveJobMutationVariables = Types.Exact<{
    input: Types.UpdateSavedJobStateInput;
}>;

export type ConfirmationPageSaveJobMutation = {
    __typename?: 'Mutation';
    updateSavedJobState?:
        | {
              __typename?: 'UpdateSavedJobStatePayload';
              savedJob: { __typename?: 'SavedJob'; job: { __typename?: 'Job'; key: string } };
          }
        | null
        | undefined;
};

export const FindReviewBeforeSubmitDraftsDocument = gql`
    query FindReviewBeforeSubmitDrafts {
        findReviewBeforeSubmitDrafts {
            drafts {
                applicationDraftId
                state
                jobTitle
                jobLocation
                applyableJob {
                    jobId
                    clientJobRef
                }
                iaUid
                employerName
                proctors
                deferMonetizationSignals
            }
        }
    }
`;

/**
 * __useFindReviewBeforeSubmitDraftsQuery__
 *
 * To run a query within a React component, call `useFindReviewBeforeSubmitDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReviewBeforeSubmitDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReviewBeforeSubmitDraftsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindReviewBeforeSubmitDraftsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        FindReviewBeforeSubmitDraftsQuery,
        FindReviewBeforeSubmitDraftsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        FindReviewBeforeSubmitDraftsQuery,
        FindReviewBeforeSubmitDraftsQueryVariables
    >(FindReviewBeforeSubmitDraftsDocument, options);
}
export function useFindReviewBeforeSubmitDraftsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        FindReviewBeforeSubmitDraftsQuery,
        FindReviewBeforeSubmitDraftsQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        FindReviewBeforeSubmitDraftsQuery,
        FindReviewBeforeSubmitDraftsQueryVariables
    >(FindReviewBeforeSubmitDraftsDocument, options);
}
export function useFindReviewBeforeSubmitDraftsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              FindReviewBeforeSubmitDraftsQuery,
              FindReviewBeforeSubmitDraftsQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        FindReviewBeforeSubmitDraftsQuery,
        FindReviewBeforeSubmitDraftsQueryVariables
    >(FindReviewBeforeSubmitDraftsDocument, options);
}
export type FindReviewBeforeSubmitDraftsQueryHookResult = ReturnType<
    typeof useFindReviewBeforeSubmitDraftsQuery
>;
export type FindReviewBeforeSubmitDraftsLazyQueryHookResult = ReturnType<
    typeof useFindReviewBeforeSubmitDraftsLazyQuery
>;
export type FindReviewBeforeSubmitDraftsSuspenseQueryHookResult = ReturnType<
    typeof useFindReviewBeforeSubmitDraftsSuspenseQuery
>;
export type FindReviewBeforeSubmitDraftsQueryResult = Apollo.QueryResult<
    FindReviewBeforeSubmitDraftsQuery,
    FindReviewBeforeSubmitDraftsQueryVariables
>;
export const CreateAutoApplyPreviewForConfirmationDocument = gql`
    mutation CreateAutoApplyPreviewForConfirmation(
        $input: CreatePreviewInput!
        $smartApplyApplicationStateInput: SmartApplyApplicationStateInput!
    ) {
        smartApplyApplicationState(input: $smartApplyApplicationStateInput) {
            createPreview(input: $input) {
                previewId
                previewHtmlFileToken
                encryptedApplicationId
                previewHtmlContentHash
            }
        }
    }
`;
export type CreateAutoApplyPreviewForConfirmationMutationFn = Apollo.MutationFunction<
    CreateAutoApplyPreviewForConfirmationMutation,
    CreateAutoApplyPreviewForConfirmationMutationVariables
>;

/**
 * __useCreateAutoApplyPreviewForConfirmationMutation__
 *
 * To run a mutation, you first call `useCreateAutoApplyPreviewForConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoApplyPreviewForConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoApplyPreviewForConfirmationMutation, { data, loading, error }] = useCreateAutoApplyPreviewForConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      smartApplyApplicationStateInput: // value for 'smartApplyApplicationStateInput'
 *   },
 * });
 */
export function useCreateAutoApplyPreviewForConfirmationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateAutoApplyPreviewForConfirmationMutation,
        CreateAutoApplyPreviewForConfirmationMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateAutoApplyPreviewForConfirmationMutation,
        CreateAutoApplyPreviewForConfirmationMutationVariables
    >(CreateAutoApplyPreviewForConfirmationDocument, options);
}
export type CreateAutoApplyPreviewForConfirmationMutationHookResult = ReturnType<
    typeof useCreateAutoApplyPreviewForConfirmationMutation
>;
export type CreateAutoApplyPreviewForConfirmationMutationResult =
    Apollo.MutationResult<CreateAutoApplyPreviewForConfirmationMutation>;
export type CreateAutoApplyPreviewForConfirmationMutationOptions = Apollo.BaseMutationOptions<
    CreateAutoApplyPreviewForConfirmationMutation,
    CreateAutoApplyPreviewForConfirmationMutationVariables
>;
export const SubmitAutoApplyApplicationDocument = gql`
    mutation SubmitAutoApplyApplication(
        $input: SubmitApplicationInput!
        $smartApplyApplicationStateInput: SmartApplyApplicationStateInput!
    ) {
        smartApplyApplicationState(input: $smartApplyApplicationStateInput) {
            submitApplication(input: $input) {
                saveFileSuccess
            }
        }
    }
`;
export type SubmitAutoApplyApplicationMutationFn = Apollo.MutationFunction<
    SubmitAutoApplyApplicationMutation,
    SubmitAutoApplyApplicationMutationVariables
>;

/**
 * __useSubmitAutoApplyApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitAutoApplyApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAutoApplyApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAutoApplyApplicationMutation, { data, loading, error }] = useSubmitAutoApplyApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      smartApplyApplicationStateInput: // value for 'smartApplyApplicationStateInput'
 *   },
 * });
 */
export function useSubmitAutoApplyApplicationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SubmitAutoApplyApplicationMutation,
        SubmitAutoApplyApplicationMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SubmitAutoApplyApplicationMutation,
        SubmitAutoApplyApplicationMutationVariables
    >(SubmitAutoApplyApplicationDocument, options);
}
export type SubmitAutoApplyApplicationMutationHookResult = ReturnType<
    typeof useSubmitAutoApplyApplicationMutation
>;
export type SubmitAutoApplyApplicationMutationResult =
    Apollo.MutationResult<SubmitAutoApplyApplicationMutation>;
export type SubmitAutoApplyApplicationMutationOptions = Apollo.BaseMutationOptions<
    SubmitAutoApplyApplicationMutation,
    SubmitAutoApplyApplicationMutationVariables
>;
export const SubmitReviewBeforeSubmitDraftDocument = gql`
    mutation SubmitReviewBeforeSubmitDraft($input: SubmitReviewBeforeSubmitDraftInput!) {
        autoApplyMutations {
            submitReviewBeforeSubmitDraft(input: $input) {
                applicationDraftId
                success
            }
        }
    }
`;
export type SubmitReviewBeforeSubmitDraftMutationFn = Apollo.MutationFunction<
    SubmitReviewBeforeSubmitDraftMutation,
    SubmitReviewBeforeSubmitDraftMutationVariables
>;

/**
 * __useSubmitReviewBeforeSubmitDraftMutation__
 *
 * To run a mutation, you first call `useSubmitReviewBeforeSubmitDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReviewBeforeSubmitDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReviewBeforeSubmitDraftMutation, { data, loading, error }] = useSubmitReviewBeforeSubmitDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitReviewBeforeSubmitDraftMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SubmitReviewBeforeSubmitDraftMutation,
        SubmitReviewBeforeSubmitDraftMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SubmitReviewBeforeSubmitDraftMutation,
        SubmitReviewBeforeSubmitDraftMutationVariables
    >(SubmitReviewBeforeSubmitDraftDocument, options);
}
export type SubmitReviewBeforeSubmitDraftMutationHookResult = ReturnType<
    typeof useSubmitReviewBeforeSubmitDraftMutation
>;
export type SubmitReviewBeforeSubmitDraftMutationResult =
    Apollo.MutationResult<SubmitReviewBeforeSubmitDraftMutation>;
export type SubmitReviewBeforeSubmitDraftMutationOptions = Apollo.BaseMutationOptions<
    SubmitReviewBeforeSubmitDraftMutation,
    SubmitReviewBeforeSubmitDraftMutationVariables
>;
export const ConfirmationPageSaveJobDocument = gql`
    mutation ConfirmationPageSaveJob($input: UpdateSavedJobStateInput!) {
        updateSavedJobState(input: $input) {
            savedJob {
                job {
                    key
                }
            }
        }
    }
`;
export type ConfirmationPageSaveJobMutationFn = Apollo.MutationFunction<
    ConfirmationPageSaveJobMutation,
    ConfirmationPageSaveJobMutationVariables
>;

/**
 * __useConfirmationPageSaveJobMutation__
 *
 * To run a mutation, you first call `useConfirmationPageSaveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmationPageSaveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmationPageSaveJobMutation, { data, loading, error }] = useConfirmationPageSaveJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmationPageSaveJobMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ConfirmationPageSaveJobMutation,
        ConfirmationPageSaveJobMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        ConfirmationPageSaveJobMutation,
        ConfirmationPageSaveJobMutationVariables
    >(ConfirmationPageSaveJobDocument, options);
}
export type ConfirmationPageSaveJobMutationHookResult = ReturnType<
    typeof useConfirmationPageSaveJobMutation
>;
export type ConfirmationPageSaveJobMutationResult =
    Apollo.MutationResult<ConfirmationPageSaveJobMutation>;
export type ConfirmationPageSaveJobMutationOptions = Apollo.BaseMutationOptions<
    ConfirmationPageSaveJobMutation,
    ConfirmationPageSaveJobMutationVariables
>;
